import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/ski-background.jpeg'


const _withScopeId = n => (_pushScopeId("data-v-3dd161bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ski-container" }
const _hoisted_2 = { class: "d-flex flex-grow-1 justify-center align-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6 text-center mb-4" }, "Forfaits", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Recharger mon Forfait ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6 text-center mb-4" }, "Offres En Station", -1))
const _hoisted_6 = {
  class: "d-flex",
  style: {"gap":"16px","flex-wrap":"wrap"}
}

import { City } from "@emblem/common/lib/cities";
import { Ref, inject, ref } from "vue";


const __default__ = {
  name: "SkiPage",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const resorts: { id: string; name: string }[] = [];

const city = inject<Ref<City>>("city");
if (!city) throw new Error("City not found");
const aeon = ref(false);

if (/(GRENOBLE)|(LYON)|(DIJON)/.test(city.value)) {
  resorts.push(
    { id: "alpedhuez", name: "Alpe d'Huez" },
    { id: "lesdeuxalpes", name: "les 2 Alpes" }
  );
  aeon.value = true;
}
if (/(DIJON)|(STRASBOURG)/.test(city.value)) {
  resorts.push({ id: "lesrousses", name: "Les Rousses" });
}

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_img, {
      src: _imports_0,
      class: "ski-background",
      cover: ""
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_card, { "max-width": "95vw" }, {
        default: _withCtx(() => [
          (aeon.value)
            ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _createVNode(_component_v_btn, {
                    block: "",
                    href: "https://www.emblem-aeon.com/identification/",
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(resorts, (resort) => {
                  return _createVNode(_component_v_btn, {
                    key: resort.id,
                    to: '/offers?categories=' + resort.id,
                    class: "flex-grow-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(resort.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                }), 64))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})